import { createContext, useContext } from 'react';

const AppBookingsContext = createContext(null);

export const useAppBookings = () => {
  const context = useContext(AppBookingsContext);
  if (!context) {
    throw new Error('useAppBookings must be used within an AppBookingsProvider');
  }
  return context;
};

export default AppBookingsContext;
